export const environment = {
    production: true,
    apiUrl: 'https://api.discoverpay.com.br',
    apiKey: '1F6A85F1-B315-4E6C-A310-80B8A11A1546',
    enigma: 'Q29uZ3JhdHVsYXRpb25zIEFydGh1ciBTY2hlcmJpdXM=',
    googleKey:
        '1028206665776-78atr57drh1hln61eqbe09kkkci592ot.apps.googleusercontent.com',
}
